import { render, staticRenderFns } from "./CbsQuickReason.vue?vue&type=template&id=3f0def83&"
import script from "./CbsQuickReason.vue?vue&type=script&lang=js&"
export * from "./CbsQuickReason.vue?vue&type=script&lang=js&"
import style0 from "./CbsQuickReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CbsQuickReason.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports